import { useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { DefaultSortTypesEnum, OptionKey } from '@/common/types';

const useFieldLevelAccessListParams = () => {
  const [sortBy, setSortBy] = useState<OptionKey>(DefaultSortTypesEnum.ASC);
  const { page, setPage, setPerPage, perPage, searchString, setSearchString } = usePaginationParams();

  return {
    sortBy,
    setSortBy,
    page,
    setPage,
    setPerPage,
    perPage,
    searchString,
    setSearchString,
  };
};

export default useFieldLevelAccessListParams;
